import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import Appointment from "../interface/appointment";
import SearchControllsProps from "../interface/searchControllsProps";
import FilterCheckbox from "../../../components/inputs/filterCheckbox/filterCheckbox";

const CheckBoxFree = (): React.JSX.Element => {
  const {
    searchControlls,
    setSearchControlls,
    appointments,
    setPaginationSettings,
  }: {
    searchControlls: SearchControllsProps;
    setSearchControlls: React.Dispatch<
      React.SetStateAction<SearchControllsProps>
    >;
    appointments: Appointment[] | null;
    setPaginationSettings: React.Dispatch<React.SetStateAction<any>>;
  } = React.useContext(AppointmentOverviewContext);

  const getFreeCount = (): number => {
    return appointments
      ? appointments.filter(
          (appointment: Appointment) =>
            appointment.status === "F" && !appointment.isSpeedcoaching
        ).length
      : 0;
  };

  const onClickHandler = (): void => {
    setPaginationSettings((prev: any) => ({
      ...prev,
      page: 1,
    }));
    setSearchControlls((prev) => ({
      ...prev,
      status: {
        ...prev.status,
        free: !prev.status.free,
      },
    }));
  };

  return (
    <FilterCheckbox
      disabled={searchControlls.loading}
      badgeContent={getFreeCount()}
      onClickHandler={onClickHandler}
      label="Frei"
      checked={searchControlls.status.free}
    />
  );
};

export default CheckBoxFree;
